import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { SlotNGController } from '../../controllers/slot-ng-controller';
import { ResizeController } from '../../controllers/resize-controller';
import componentStyles from './tufts-footer.css.lit';
import '../tufts-container/tufts-container';
import { classMap } from 'lit/directives/class-map.js';

/**
 * The tufts-footer component
 * @element tufts-footer
 *
 * @slot logo
 * @slot menu
 * @slot address
 * @slot phone
 * @slot social-links
 * @slot copyright
 * @slot terms
 * @slot note
 */
@customElement('tufts-footer')
export class TuftsFooter extends OutlineElement {
  ngSlot = new SlotNGController(this);
  resizeController: ResizeController = new ResizeController(this, {
    breakpoints: [768, 1440],
  });
  static styles = [componentStyles];
  @property({
    type: String,
    reflect: true,
    attribute: 'min-pulse-size',
  })
  minPulseSize = '25rem';

  render() {
    const containerClasses = {
      'footer-container': true,
      'mobile': this.resizeController.currentBreakpointRange === 0,
      'medium': this.resizeController.currentBreakpointRange === 1,
      'large': this.resizeController.currentBreakpointRange === 2,
    };
    return html`
      <tufts-container container-width="full" padding="0">
        <tufts-container
          background-color="blue_dark"
          padding="0"
          pulse-orientation="${this.resizeController.currentBreakpointRange ===
          2
            ? 'bottom-left'
            : 'top-right'}"
          max-pulse-size="32rem"
          min-pulse-size="${this.minPulseSize}"
          pulse-mobile="true"
        >
          <div class="${classMap(containerClasses)}">
            ${this.ngSlot.conditionalNGSlot('logo')}
            <div class="footer-content">
              <slot name="menu"></slot>
              <div class="below-menu">
                <div class="address-phone">
                  ${this.ngSlot.conditionalNGSlot('address')}
                  ${this.ngSlot.conditionalNGSlot('phone')}
                </div>
                <div class="social-wrapper">
                  ${this.ngSlot.conditionalNGSlot('social-links')}
                  <div class="copyright-terms">
                    ${this.ngSlot.conditionalNGSlot('copyright')}
                    ${this.ngSlot.conditionalNGSlot('terms')}
                    <slot name="piwik"></slot>
                  </div>
                </div>
              </div>
              ${this.ngSlot.conditionalNGSlot('note')}
            </div>
          </div>
        </tufts-container>
      </tufts-container>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-footer': TuftsFooter;
  }
}
